// Lazy-singleton accessor for the live-stream controller. The real controller
// is created in useAgentStore.js *after* the store (it needs the store's
// getState/setState), so slices and lifecycle helpers cannot import it directly
// without forming a cycle back to the store. They call getLiveStreamController()
// instead, and useAgentStore wires the concrete controller via
// setLiveStreamController during module init.
//
// A plain accessor (rather than a Proxy) keeps the indirection obvious and
// avoids re-binding a method on every property access — the live-chunk path
// calls through here per ui_chunk event.
let _controller = null;

export function setLiveStreamController(controller) {
  _controller = controller;
}

export function getLiveStreamController() {
  if (!_controller) {
    throw new Error("streamController accessed before initialization");
  }
  return _controller;
}
